/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BinderClaimPaginationResponseDto,
  BinderClaimResponseDto,
  CreateBinderClaimPayloadDto,
  ErrorResponse,
  FilterBinderClaimsQueryDto,
} from '../models/index';
import {
    BinderClaimPaginationResponseDtoFromJSON,
    BinderClaimPaginationResponseDtoToJSON,
    BinderClaimResponseDtoFromJSON,
    BinderClaimResponseDtoToJSON,
    CreateBinderClaimPayloadDtoFromJSON,
    CreateBinderClaimPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FilterBinderClaimsQueryDtoFromJSON,
    FilterBinderClaimsQueryDtoToJSON,
} from '../models/index';

export interface FilterBinderClaimsRequest {
    filterBinderClaimsQueryDto: FilterBinderClaimsQueryDto;
    field?: FilterBinderClaimsFieldEnum;
    order?: FilterBinderClaimsOrderEnum;
    page?: number;
    pageSize?: number;
}

export interface RegisterBinderClaimRequest {
    createBinderClaimPayloadDto: CreateBinderClaimPayloadDto;
}

/**
 * 
 */
export class BinderClaimApi extends runtime.BaseAPI {

    /**
     * Filter binder claims
     */
    async filterBinderClaimsRaw(requestParameters: FilterBinderClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderClaimPaginationResponseDto>> {
        if (requestParameters['filterBinderClaimsQueryDto'] == null) {
            throw new runtime.RequiredError(
                'filterBinderClaimsQueryDto',
                'Required parameter "filterBinderClaimsQueryDto" was null or undefined when calling filterBinderClaims().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder-claim/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterBinderClaimsQueryDtoToJSON(requestParameters['filterBinderClaimsQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderClaimPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter binder claims
     */
    async filterBinderClaims(requestParameters: FilterBinderClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderClaimPaginationResponseDto> {
        const response = await this.filterBinderClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Register binder claim
     */
    async registerBinderClaimRaw(requestParameters: RegisterBinderClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BinderClaimResponseDto>> {
        if (requestParameters['createBinderClaimPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createBinderClaimPayloadDto',
                'Required parameter "createBinderClaimPayloadDto" was null or undefined when calling registerBinderClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/binder-claim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBinderClaimPayloadDtoToJSON(requestParameters['createBinderClaimPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BinderClaimResponseDtoFromJSON(jsonValue));
    }

    /**
     * Register binder claim
     */
    async registerBinderClaim(requestParameters: RegisterBinderClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BinderClaimResponseDto> {
        const response = await this.registerBinderClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FilterBinderClaimsFieldEnum = {
    Insured: 'insured',
    Status: 'status',
    LineOfBusiness: 'lineOfBusiness',
    DateReported: 'dateReported',
    ClaimsHandler: 'claimsHandler'
} as const;
export type FilterBinderClaimsFieldEnum = typeof FilterBinderClaimsFieldEnum[keyof typeof FilterBinderClaimsFieldEnum];
/**
 * @export
 */
export const FilterBinderClaimsOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type FilterBinderClaimsOrderEnum = typeof FilterBinderClaimsOrderEnum[keyof typeof FilterBinderClaimsOrderEnum];
